import ListItemIcon from './ListItemIcon';

export default ListItemIcon;
